import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  title?: string;
  disabled?: boolean;
  tooltip?: string;
  className?: string;
  onClick?: () => void;
}

const BackButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ title = 'Back', onClick, className, tooltip = 'Go back', ...props }: ButtonProps, ref) => {
    return (
      <button
        type="button"
        onClick={onClick}
        className={`bg-transparent hover:underline  text-black font-sofiaSans font-bold py-2 rounded-full focus:outline-none w-auto flex items-center relative ${className}`}
        {...props}
      >
        <FontAwesomeIcon title="" icon={faAngleLeft} className="mr-1 text-lg" />
        <span className="flex items-center">{title}</span>
      </button>
    );
  },
);

export default BackButton;
